enum GameState {
  INITIAL,
  GAME_START,
  GAME_ONGOING,
  GAME_WIN,
  GAME_LOSE,
  PRIZE_SHOWN,
}

export { GameState };
